





















import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";

interface Props {
  /** Kontírozás fej azonosító (hmifcapiverkacc.szam) */
  accId: number;
}

interface Computed {
  url: string;
  apiSearchName: string;
  columns: any[];
}

/**
 * Verk bizonylat tételei (imifcapiverkacc) — a háromszintű Verk lista 3. szintje, csak olvasásra.
 * A tételeket a tárolt eljárás tölti, a felületen nincs rajtuk művelet.
 */
export default Vue.extend<{}, {}, Computed, Props>({
  name: "VerkInvoiceItemList",

  components: {
    ApiSearchPage,
  },

  props: {
    accId: { type: Number, required: true },
  },

  computed: {
    url(): string {
      return `iface-sync-verk-invoice/item-search/${this.accId}`;
    },

    /** Fejenként egyedi név — az ApiSearchPage eventBus-csatornái globálisak. */
    apiSearchName(): string {
      return `VerkInvoiceItemApiSearch_${this.accId}`;
    },

    columns(): any[] {
      return [
        { field: "description", title: "Megnevezés", cell: "disabledText" },
        { field: "contraGlAccNo", title: "Ellenszámla", width: 110, cell: "disabledText" },
        { field: "contraCostCenter", title: "Ellen-költséghely", width: 120, cell: "disabledText" },
        { field: "contraProjectNo", title: "Ellen-projekt", width: 110, cell: "disabledText" },
        { field: "netAmount", title: "Nettó (dev.)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "netAmountHuf", title: "Nettó (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "vatBaseAmount", title: "Áfa-alap (dev.)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "vatBaseAmountHuf", title: "Áfa-alap (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "vatCode", title: "Áfa-kód", width: 80, cell: "disabledText" },
        { field: "vatAmount", title: "Áfa (dev.)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "vatAmountHuf", title: "Áfa (HUF)", width: 110, type: ColumnType.Money, filterable: false },
      ];
    },
  },
});
